export const URL = "https://karaoke-backend.easyway.pro.vn";

// https://back-end-node-kappa.vercel.app

// https://api-karaoke.onrender.com

// http://localhost:5000
